// Mock data for Climb Capital clone

export const navigationLinks = [
  { name: 'Home', path: '/' },
  { name: 'About Us', path: '/about-us' },
  { 
    name: 'Services', 
    path: '/services',
    dropdown: [
      { name: 'RESEARCH SERVICE', path: '/research-service' },
      { name: 'IMPORTANT CORPORATE ANNOUNCEMENT', path: '/corporate-announcement' }
    ]
  },
  { name: 'Performance Reports', path: '/our-performance' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'FAQs', path: '/faqs' }
];

export const testimonials = [
  {
    id: 1,
    name: 'CHIRAG MODY',
    date: 'October 2025',
    title: 'Have been very consistent in giving excellent Recommendations.',
    text: 'truly glad the recommendations have been consistently helpful To build a strong long-term investment portfolio'
  },
  {
    id: 2,
    name: 'SAMIR MAHETALIA',
    date: 'October 2025',
    title: 'Peaceful Investing, Great Job Being Done.',
    text: 'Your Subscription is worth value for money'
  },
  {
    id: 3,
    name: 'GIRISH V AGRAWAL',
    date: 'October 2025',
    title: 'It\'s almost a year I have been a member of Climb Capital and I am glad to say that it\'s worth.',
    text: 'Excellent Recommendations and Fundamentally strong Stocks'
  },
  {
    id: 4,
    name: 'Pratik Gawli',
    date: 'October 2025',
    title: 'POSITIVE',
    text: 'Made investing experience very good with availability of good information and easy to understand details'
  },
  {
    id: 5,
    name: 'Jayesh Bhanusali',
    date: 'October 2025',
    title: 'FEEDBACK',
    text: 'Excellent . Keep up the good work. You are greatly helping the retail investor community. I would recommend your service to all investors who would like to compound the money in safe and secure manner. Thanks a lot sir.'
  }
];

export const complaintsData = {
  headers: ['Received from', 'Pending at the end of last month', 'Received', 'Resolved', 'Total Pending #', 'Pending complaints > 3 months', 'Average Resolution time (in days)'],
  rows: [
    {
      source: 'Directly from investor',
      pending: 'Nil',
      received: 'Nil',
      resolved: 'Nil',
      totalPending: 'Nil',
      pendingOver3Months: 'Nil',
      avgResolution: 'N.A'
    },
    {
      source: 'Other Sources (if any)',
      pending: 'Nil',
      received: 'Nil',
      resolved: 'Nil',
      totalPending: 'Nil',
      pendingOver3Months: 'Nil',
      avgResolution: 'N.A'
    },
    {
      source: 'SEBI (SCORES)',
      pending: 'Nil',
      received: 'Nil',
      resolved: 'Nil',
      totalPending: 'Nil',
      pendingOver3Months: 'Nil',
      avgResolution: 'N.A'
    }
  ],
  grandTotal: {
    source: 'Grand Total',
    pending: 'Nil',
    received: 'Nil',
    resolved: 'N.A',
    totalPending: 'Nil',
    pendingOver3Months: 'Nil',
    avgResolution: 'N.A.'
  }
};

export const pricingPlans = [
  {
    id: 1,
    name: 'SILVER+',
    duration: '12 Months',
    originalPrice: '\u20B930000',
    discountedPrice: '\u20B920000',
    features: [
      'Research Based Stock Recommendations',
      'Entry & Exit Recommendations',
      'Regular Portfolio Reviews',
      'Email & WhatsApp Support'
    ]
  },
  {
    id: 2,
    name: 'GOLD+',
    duration: '12 Months',
    originalPrice: '\u20B950000',
    discountedPrice: '\u20B935000',
    features: [
      'All SILVER+ Features',
      'Personalized Investment Strategy',
      'Quarterly Portfolio Rebalancing',
      'Priority Support',
      'Market Updates & Insights'
    ],
    popular: true
  },
  {
    id: 3,
    name: 'PLATINUM+',
    duration: '12 Months',
    originalPrice: '\u20B980000',
    discountedPrice: '\u20B960000',
    features: [
      'All GOLD+ Features',
      'Dedicated Relationship Manager',
      'Monthly Portfolio Reviews',
      'Tax Planning Assistance',
      'Exclusive Investment Opportunities'
    ]
  }
];

export const faqs = [
  {
    id: 1,
    question: 'Is CLIMB CAPITAL Equity Research Service right for me?',
    answer: 'If you are looking for well-researched stock ideas with a long-term investment horizon and want to build wealth systematically, then our Equity Research Service is ideal for you. We cater to investors who prefer fundamental analysis-based recommendations over speculative trading.'
  },
  {
    id: 2,
    question: 'How does this service work?',
    answer: 'Once you subscribe to our service, you will receive carefully researched stock recommendations via email and WhatsApp. Each recommendation comes with a detailed research report explaining the investment rationale, entry price, target price, and stop-loss levels. You execute the trades in your own demat account.'
  },
  {
    id: 3,
    question: 'How can CLIMB CAPITAL help me?',
    answer: 'CLIMB CAPITAL helps you make informed investment decisions by providing thoroughly researched stock ideas. We save you time and effort by doing the research for you, allowing you to focus on your core activities while building a wealth-creating portfolio.'
  },
  {
    id: 4,
    question: 'How will I receive the recommendations?',
    answer: 'All recommendations are delivered through multiple channels - Email and WhatsApp. You will also receive updates on existing recommendations, including profit booking levels, stop-loss revisions, and exit calls through the same channels.'
  },
  {
    id: 5,
    question: 'What else will I receive apart from recommendations?',
    answer: 'Apart from stock recommendations, you will receive detailed research reports, regular portfolio updates, market insights, and access to a dedicated relationship manager who will assist you throughout your investment journey with us.'
  },
  {
    id: 6,
    question: 'Is there a minimum capital requirement for me to start?',
    answer: 'While there is no mandatory minimum capital requirement, we recommend starting with ₹5 lakhs to facilitate proper portfolio diversification. This allows you to invest approximately ₹25,000 per stock idea and build a well-diversified portfolio of 15-20 stocks over time.'
  },
  {
    id: 7,
    question: 'How does CLIMB CAPITAL make money?',
    answer: 'We charge a fixed subscription fee for our research services. We do not engage in profit sharing or charge any hidden fees. Our revenue comes solely from the subscription fees paid by our clients for accessing our research and recommendations.'
  },
  {
    id: 8,
    question: 'Whom can I contact if I have any concerns or queries?',
    answer: 'You can reach out to your dedicated relationship manager or contact us at info@climbcapital.in. You can also call us at +91 9372273366 during business hours. We are committed to addressing your concerns promptly.'
  },
  {
    id: 9,
    question: 'What is CLIMB CAPITAL relevant experience in the market?',
    answer: 'CLIMB CAPITAL is a SEBI-registered Research Analyst firm (Registration No. INH000018151). Our team comprises experienced market professionals with a strong background in equity research, fundamental analysis, and portfolio management.'
  },
  {
    id: 10,
    question: 'Is this the correct time to start investing?',
    answer: 'There is never a perfect time to start investing. What matters is staying invested for the long term. Our staggered investment approach helps you build positions gradually, taking advantage of market corrections rather than trying to time the market.'
  },
  {
    id: 11,
    question: 'Will I also get to know when to exit a stock?',
    answer: 'Yes, absolutely. We provide complete guidance on exits, including profit booking levels and stop-loss triggers. You will receive timely updates when it is time to exit a position, either to book profits or to limit losses.'
  },
  {
    id: 12,
    question: 'At what interval will I receive the stock recommendations?',
    answer: 'Upon subscription, you will receive 3-4 stocks that are currently in the buying range. Thereafter, you will receive 1-2 new stock recommendations every month, depending on market conditions and availability of quality opportunities.'
  },
  {
    id: 13,
    question: 'Are the fees refundable or membership transferable?',
    answer: 'Fees are non-refundable once the service has commenced. Membership is non-transferable and is valid only for the registered subscriber. Please refer to our Cancellation Policy for detailed terms and conditions.'
  }
];

export const footerLinks = {
  additionalLinks: [
    { name: 'Privacy Policy', path: '/privacy-page' },
    { name: 'Terms of Use', path: '/terms-page' },
    { name: 'Cancellation Policy', path: '/cancellation-policy' },
    { name: 'Disclaimer', path: '/disclaimer' },
    { name: 'Grievance Policy', path: '/grievance-policy' },
    { name: 'Investor Charter', path: '/pdf/INVESTOR CHARTER.pdf', isExternal: true }
  ]
};

export const contactInfo = {
  phone: '+91 9372273366',
  email: 'info@climbcapital.in',
  sebiReg: 'INH000018151',
  sebiDetails: {
    registeredName: 'CLIMB CAPITAL SERVICES PRIVATE LIMITED',
    typeOfRegistration: 'SEBI REGISTERED RESEARCH ANALYST (Non-Individual)',
    legalName: 'CLIMB CAPITAL',
    sebiRegNo: 'INH000018151'
  },
  officeAddress: {
    building: 'SEBI Bhavan BKC, Plot No.C4-A, \'G\' Block',
    complex: 'Bandra-Kurla Complex, Bandra (East)',
    city: 'Mumbai - 400051, Maharashtra'
  }
};

export const performanceData = [
  {
    date: '21/10/25',
    stock: 'B****** B******',
    recommendedPrice: '3070.00',
    exitPrice: '5000.00',
    percentageGain: '-',
    status: 'Open'
  },
  {
    date: '16/10/25',
    stock: 'A***** A*****',
    recommendedPrice: '2450.00',
    exitPrice: '3200.00',
    percentageGain: '30.61%',
    status: 'Close'
  },
  {
    date: '10/10/25',
    stock: 'C****** C******',
    recommendedPrice: '1850.00',
    exitPrice: '2100.00',
    percentageGain: '13.51%',
    status: 'Close'
  }
];
